import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import {
  Accordion,
  AccordionDetails,
  Box,
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  Divider,
} from "@material-ui/core";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import NoRecordFound from "src/components/NoRecordFound";
import { VendorInvoice } from "../VendorInvoice/VendorInvoice";
import { Card } from "./Card";
import Heading from "./Heading";
import { useStyles } from "./styles";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export function Doc({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const { ordNum } = useParams<{ ordNum: any }>();
  const getNotesData = async () => {
    try {
      setLoader(true);
      const { vendorDocuments } = await fetchWrapper.get(
        `get-documents-for-vendor-portal-by-order-number/${ordNum}`
      );
      setInvoiceData(vendorDocuments);
      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  React.useEffect(() => {
    if (expand) {
      getNotesData();
    }
  }, [expand]);

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={() => updateExpandStatus(5)}>
          <Heading heading="Documents" />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Grid container direction="row">
              <Grid xs={12} md={12}>
                <Box color="text.secondary" mb={1}>
                  <Typography className={classes.heading}>{"Approved"}</Typography>
                  <Divider />
                </Box>
                {Boolean(Object.keys(invoiceData).length) ? (
                  Object.values(invoiceData).map((item, i) => (
                    <Card key={i} index={i} RowData={item} />
                  ))
                ) : (
                  <>
                    <NoRecordFound />
                  </>
                )}
                <Box color="text.secondary" mt={2}>
                  <Typography className={classes.heading}>{"Pending approval"}</Typography>
                  <Divider />
                </Box>
                <VendorInvoice expand={expand} />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}
